import { inlineLyricLines } from './listeningPresentation.mjs';

/** Bounded, non-interactive metadata for a song row. */
export function rowTags(value) {
  const tags = (Array.isArray(value) ? value : [value || ''])
    .flatMap(tag => String(tag).split(/[,，;；]/u))
    .map(tag => tag.trim()).filter(Boolean);
  return [...new Set(tags)].slice(0, 2);
}

/** Search presentation only: never changes the result set or search request. */
export function lyricsOnlyMatch(music, query) {
  const normalized = String(query || '').trim().replace(/\s+/gu, ' ');
  if (!normalized) return null;
  const pattern = new RegExp(normalized.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'iu');
  const metadata = music.metadata || {};
  if ([music.title, music.display_name, metadata.tags, metadata.gpt_description_prompt]
    .some(value => pattern.test(String(value || '').replace(/\s+/gu, ' ')))) return null;
  const lyrics = inlineLyricLines(metadata.prompt).join(' ').replace(/\s+/gu, ' ');
  const match = pattern.exec(lyrics);
  if (!match) return null;
  const end = Math.min(lyrics.length, match.index + match[0].length + 32);
  return {
    // Keep the hit visible even when the mobile text column is narrow.
    before: match.index ? '…' : '',
    match: match[0],
    after: lyrics.slice(match.index + match[0].length, end) + (end < lyrics.length ? '…' : ''),
  };
}
